// extracted by mini-css-extract-plugin
module.exports = {"PageBqMob":"PageBq_PageBqMob__mYLq3"};